import React, { Fragment } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';

import { siteSyncDetailLoad } from "store/models/siteSync";
import { DetailLoadComponent } from 'components/common';


const SiteSyncValue = (props) => {
  return (
    <DetailLoadComponent
      apiLoad={siteSyncDetailLoad}
      {...props}
      getDetailUrl={(id, item) => props.model.urls.detail(id)}
      render={({ id, item, linkPath }) => {
        const value = item?.city?.name || id;

        return (
          <Fragment>
            {props.asLink && linkPath ?
              <Link to={linkPath}>{value}</Link> :
              <span>{value}</span>}
          </Fragment>
        );
      }}
    />
  );
};

const mapState = state => ({
  router: state.router,
  authToken: state.auth.token,
  model: state.siteSync,
});

export default connect(mapState)(SiteSyncValue);
